var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrbitalDetailsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000004201"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.97004 6.01566C8.97004 7.43556 7.81898 8.58662 6.39908 8.58662C4.97918 8.58662 3.82812 7.43556 3.82812 6.01566C3.82812 4.59576 4.97918 3.4447 6.39908 3.4447C7.81898 3.4447 8.97004 4.59576 8.97004 6.01566Z",
    stroke: "#F0F0F0",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.4676 7.4903C10.8089 9.73848 8.74689 11.285 6.39848 11.285C3.49161 11.285 1.12888 8.92226 1.12888 6.01539C1.12888 3.10851 3.49161 0.745782 6.39848 0.745782C8.76121 0.745782 10.8089 2.30662 11.4676 4.55479C11.5106 4.55479 11.5392 4.54047 11.5822 4.54047C10.9235 2.23502 8.81849 0.631226 6.39848 0.631226C3.42001 0.631226 1 3.03691 1 6.01539C1 8.99386 3.42001 11.3995 6.38416 11.3995C8.78985 11.3995 10.9091 9.79575 11.5678 7.4903C11.5392 7.50462 11.4962 7.4903 11.4676 7.4903Z",
    fill: "#F0F0F0",
    stroke: "#F0F0F0",
    strokeWidth: 0.33651
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.7256 7.28997C11.024 7.28997 10.4512 6.71719 10.4512 6.01553C10.4512 5.31387 11.024 4.74109 11.7256 4.74109C12.4273 4.74109 13.0001 5.31387 13.0001 6.01553C13.0001 6.71719 12.4273 7.28997 11.7256 7.28997ZM11.7256 4.8986C11.1099 4.8986 10.6087 5.39979 10.6087 6.01553C10.6087 6.63127 11.1099 7.13246 11.7256 7.13246C12.3414 7.13246 12.8425 6.63127 12.8425 6.01553C12.8569 5.39979 12.3414 4.8986 11.7256 4.8986Z",
    fill: "#F0F0F0",
    stroke: "#F0F0F0",
    strokeWidth: 0.33651
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrbitalDetailsIcon);
export default __webpack_public_path__ + "static/media/Orbital-details-icon.d32f9dada6cadb62a7e16289da6de471.svg";
export { ForwardRef as ReactComponent };